<template>
    <b-container fluid class="overflow-hidden px-0 layout">
        <b-row no-gutters>
            <b-col>
                <ImgBackground />
            </b-col>
            <b-col class="p-3 bg-white" md="12" lg="6">
                <b-row>
                    <b-col>
                        <div class="d-flex justify-content-end">
                            <BtnDropdownLanguage />
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div class="d-flex justify-content-center my-4">
                            <LogoCoBlue />
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div class="d-flex justify-content-center mt-4">
                            <slot name="form" />
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <AlertCookies />
    </b-container>
</template>

<script>
import AlertCookies from './AlertCookies'
import LogoCoBlue from './LogoCoBlue'
import ImgBackground from './ImgBackground'
import BtnDropdownLanguage from './BtnDropdownLanguage'

export default {
    name: 'Layout',
    components: {
        AlertCookies,
        LogoCoBlue,
        ImgBackground,
        BtnDropdownLanguage,
    },
}
</script>

<style lang="scss" scoped>
.layout {
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: 400;
}
</style>
